module.exports = __webpack_public_path__ + "img/CONDICIONES_IDA_REGRESO.894130cc.jpg";